import { Autocomplete, InputLabel, TextField } from "@mui/material"
import { Fragment } from "react"
import { uid } from "uid"

function AutoCompleteA({ id, label, name, options, placeholder, renderValue, ...rest }) {
  id = id || uid(6)

  return (
    <Fragment>
      {label &&
        <InputLabel
          htmlFor={id}
        >{label}
        </InputLabel>
      }
      <Autocomplete
        size="small"
        variant="AutoComp"
        options={options || []}
        renderInput={(params) => <TextField placeholder={placeholder || null} name={name || null}{...params} />}
        getOptionLabel={(options) => renderValue ? options?.value : options}
        {...rest}
      />
    </Fragment>
  )
}

export default AutoCompleteA